"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDateStringToMidnight = exports.scrollToElement = exports.isVisibleInViewport = exports.getDurationLabel = exports.formatDate = void 0;
var i18n_1 = require("@wordpress/i18n");
var dateOptions = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
};
function formatDate(date) {
    var bodyTag = document.getElementsByTagName('html');
    var language = bodyTag[0].getAttribute('lang');
    return new Date(date).toLocaleDateString(language, dateOptions);
}
exports.formatDate = formatDate;
function getDurationLabel(durationDays) {
    var weeks = parseInt(durationDays) / 7;
    var label = "".concat(weeks, " ").concat(weeks > 1 ? (0, i18n_1.__)("weeks", "projects-abroad") : (0, i18n_1.__)("week", "projects-abroad"));
    if (durationDays % 7 !== 0) {
        label = "".concat(durationDays, " ").concat(durationDays > 1 ? (0, i18n_1.__)("days", "projects-abroad") : (0, i18n_1.__)("day", "projects-abroad"));
    }
    return label;
}
exports.getDurationLabel = getDurationLabel;
function isVisibleInViewport(el) {
    var mobileCartBanner = document.querySelector('.appform-cart-banner');
    var topOffset = mobileCartBanner ? mobileCartBanner.offsetHeight : 0;
    var rect = el.getBoundingClientRect();
    var isTopVisible = rect.top >= topOffset;
    var hasSpaceBelow = rect.bottom + 200 <= (window.innerHeight);
    return isTopVisible && hasSpaceBelow;
}
exports.isVisibleInViewport = isVisibleInViewport;
function scrollToElement(element) {
    if (element) {
        var mobileCartBanner = document.querySelector('.appform-cart-banner');
        var topOffset = mobileCartBanner ? mobileCartBanner.offsetHeight : 0;
        var rect = element.getBoundingClientRect();
        var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        window.scrollTo({
            top: rect.top + window.scrollY - topOffset,
            behavior: scrollBehavior,
        });
    }
}
exports.scrollToElement = scrollToElement;
/**
 * An oddity in Javascript means that:
 * > When the time zone offset is absent, date-only forms are interpreted as a UTC time
 * > and date-time forms are interpreted as local time.
 * > This is due to a historical spec error that was not consistent with ISO 8601 but could not be changed due to web compatibility.
 * Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
 *
 * We therefore set our date strings to Midnight,
 * ensuring that the dates are treated as local time.
 * This is needed as functions like `getHour()` always return local time.
 *
 * @param string dateString
 * @return string
 */
function setDateStringToMidnight(dateString) {
    if (dateString.indexOf("T") !== -1) {
        dateString = dateString.substring(0, dateString.indexOf("T"));
    }
    return dateString + 'T00:00:00';
}
exports.setDateStringToMidnight = setDateStringToMidnight;
